import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

export let startRecentTransfersTable = accountID => {
  const root = createRoot(document.getElementById('recent_transfers_table'))
  root.render(<App accountID={accountID} />)
}
